import React from 'react';
import {
  RailsItem,
  RailsThumbnailItem,
} from '@sls-react/typings/services/rails/item';
import { Avatar } from '@sls-react/design-system';
import LockerLink from '@sls-react/components/Links/LockerLink';

interface Props {
  item: RailsThumbnailItem | RailsItem;
}

const UsernameAvatarRow: React.FC<Props> = ({ item }) => {
  const username = item.seller.username;
  const cx =
    'text-xs text-white font-semibold -m-2 p-2 overflow-hidden hover:underline hover:text-white';

  if (item.seller.avatar_url) {
    return (
      <LockerLink
        username={username}
        className={`${cx} flex items-center space-x-2`}
      >
        <Avatar size="small" avatarUrl={item.seller.avatar_url} />
        <span className="overflow-ellipsis whitespace-nowrap">{username}</span>
      </LockerLink>
    );
  }

  return (
    <LockerLink
      username={username}
      className={`${cx} overflow-ellipsis whitespace-nowrap`}
    >
      {username}
    </LockerLink>
  );
};

export default UsernameAvatarRow;
